// extracted by mini-css-extract-plugin
export default {"SummaryRow":"SummaryRow_SummaryRow","value":"SummaryRow_value","loadingValue":"SummaryRow_loadingValue"};